<!-- 维护白名单弹窗 -->
<template>
<el-dialog :before-close="handleClose" :title="isEdit ? '编辑白名单' : '新建白名单'" :visible.sync="dialogVisible" class="maintainWhiteList" width="600px" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="params" :rules="rules" label-width="110px" class="form" ref="maintainWhiteListForm">
        <el-form-item label="用户手机号码" prop="mobileno" v-if="!isEdit" class="mobileno">
            <el-input v-model="params.mobileno" placeholder="请输入用户手机号进行查询"></el-input>
            <el-button type="primary" @click="handleMobilenoChange">查询</el-button>
        </el-form-item>
        <el-form-item label="用户 ID/名称" v-if="showUserMsg">
            <div class="nameId" :class="{isEdit: isEdit}">{{ userMsg.customername }}（{{userMsg.customerinnerid}}）</div>
        </el-form-item>
        <el-form-item label="用户头像" v-if="showUserMsg" class="customerurlBox">
            <img :src="userMsg.customerurl ? userMsg.customerurl : require('@/common/images/shop/header_picture.png')" class="customerurl" alt="">
        </el-form-item>
        <el-form-item label="有效日期" prop="expiretime">
            <el-date-picker v-model="params.expiretime" :picker-options="expireTimeOPtion" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="有效日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="有效内容" prop="kmctypelist">
            <el-checkbox-group v-model="params.kmctypelist">
                <el-checkbox label="7">课程</el-checkbox>
                <el-checkbox label="2">直播</el-checkbox>
                <el-checkbox label="3">报告</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateCustomer">确定</el-button>
    </span>
</el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import {getCustomerInfoByMobile, getWhiteCustomInfo, saveOrUpdateCustomer} from '@/api/accountApi.js'
export default {
    data() {
        const checkKmctypelist = (rule, value, callback) => {
            if (!value.length) {
                callback(new Error('请选择有效内容'))
            } else {
                callback()
            }
        }
        return {
            dialogVisible: false,
            isEdit: false,
            params: {
                customerinnerid: '',
                kmctypelist: [],
                expiretime: '',
                mobileno: '',
                innerid: ''
            },
            rules: {
                mobileno: [
                    {required: true, message: '请输入用户手机号进行查询', trigger: 'blur'}
                ],
                expiretime: [
                    {required: true, message: '请选择有效日期', trigger: 'blur'}
                ],
                kmctypelist: [
                    {required: true, message: '请选择有效内容', trigger: 'blur'},
                    {validator: checkKmctypelist, trigger: 'blur'}
                ]
            },
            showUserMsg: false,
            userMsg: {},
            expireTimeOPtion: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7 //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpen(innerid) {
            this.dialogVisible = true
            if (innerid) {
                this.isEdit = true
                this.params.innerid = innerid
                this.getWhiteCustomInfo(innerid)
            } else {
                this.isEdit = false
            }
        },
        handleClose() {
            this.dialogVisible = false
            this.isEdit = false
            this.params.customerinnerid = ''
            this.params.kmctypelist = []
            this.params.expiretime = ''
            this.params.innerid = ''
            this.params.mobileno = ''
            this.showUserMsg = false
            this.userMsg = {}
        },
        handleMobilenoChange() {
            let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/ // 手机号验证规则
            if (this.params.mobileno && reg.test(this.params.mobileno)) {
                getCustomerInfoByMobile({
                    data: {mobileno: this.params.mobileno},
                    success: data => {
                        this.userMsg = data.data
                        this.params.customerinnerid = data.data.customerinnerid
                        this.showUserMsg = true
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            } else {
                this.$message.warning('请输入正确的手机号查询！')
            }
        },
        getWhiteCustomInfo(innerid) {
            this.setLoading(true)
            getWhiteCustomInfo({
                data: {innerid},
                success: data => {
                    this.setLoading(false)
                    this.params.customerinnerid = data.data.customerinnerid
                    this.params.kmctypelist = data.data.kmctypelist.split(',')
                    this.params.expiretime = data.data.expiretime
                    this.userMsg.customername = data.data.customername
                    this.userMsg.customerinnerid = data.data.customerinnerid
                    this.userMsg.customerurl = data.data.customerurl
                    this.showUserMsg = true
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        saveOrUpdateCustomer() {
            this.$refs.maintainWhiteListForm.validate(valid => {
                if (valid) {
                    let params = {
                        customerinnerid: this.params.customerinnerid,
                        kmctypelist: this.params.kmctypelist.join(','),
                        expiretime: this.params.expiretime,
                        innerid: this.params.innerid
                    }
                    this.setLoading(true)
                    saveOrUpdateCustomer({
                        data: params,
                        success: data => {
                            this.setLoading(false)
                            this.$message.success(data.msg)
                            if (this.isEdit) {
                                this.$emit('editWhiteListItemSuccess')
                            } else {
                                this.$emit('addWhiteListItemSuccess')
                            }
                            this.handleClose()
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                } else {
                    this.$message.warning('请完善您的数据！')
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.maintainWhiteList {
    .el-dialog__body {
        padding-right: 20px;
        .el-form {
            margin-top: 0;
            .el-form-item {
                margin-bottom: 15px;
                &:last-of-type {
                    margin-bottom: 0;
                }
                .customerurl {
                    width: 80px;
                    height: 80px;
                }
                &.customerurlBox {
                    .el-form-item__label {
                        line-height: 80px;
                    }
                }
                &.mobileno {
                    .el-form-item__content {
                        display: flex;
                        // align-items: center;
                        line-height: 40px;
                        .el-input {
                            flex: 1;
                            margin-right: 10px;
                            
                        }
                        .el-button {
                            min-width: 68px;
                            width: 68px;
                            margin-bottom: 0;
                            height: 32px;
                            position: relative;
                            top: 4px;
                        }
                    }
                }
                .el-checkbox-group {
                    .el-checkbox {
                        margin-right: 20px;
                        .el-checkbox__input {
                            height: 14px;
                        }
                        .el-checkbox__label {
                            line-height: 14px;
                            position: relative;
                            top: 1px;
                            padding-left: 5px;
                            color: #303133;
                        }
                        &.is-checked {
                            .el-checkbox__label {
                                color: #303133;
                            }
                        }
                    }
                }
                .nameId {
                    &.isEdit {
                        height: 32px;
                        display: flex;
                        align-items: center;
                        box-sizing: border-box;
                        width: 100%;
                        background: #EEEEEE;
                        border: 1px solid #D8DCE6;
                        border-radius: 4px;
                        padding: 0 12px;
                        margin: 4px 0;
                        color: #303133;
                    }
                }
                .el-form-item__error {
                    padding-top: 6px;
                }
            }
        }
    }
}
</style>